import { ViewModel,View, ObservableArray } from "binder"
import  { PublishView } from "./publish-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { CallServerView } from "src/formBuilder/datamodel/dataModelBuilder/methodManipulation/methodBody/executablePart/callServer/callServer-view";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class PublishViewModel extends WindowViewModel{
    public getTitle(): string {
        return "Publish To Server";
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    
        this.processes = ObservableArray.create<process>();
        this.customServices = ObservableArray.create<customService>();
        this.reports = ObservableArray.create<report>();
        this.features = ObservableArray.create<Feature>();

        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new PublishView();
    }
    public getTypeId(): string {
        return "VM-5255F356-84A1-4124-9733-59CDC02E052A"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    public set username(v: string) { this._username = v; } public get username(): string { return this._username;} private _username: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password;} private _password: string;
    public set hostAddress(v: string) { this._hostAddress = v; } public get hostAddress(): string { return this._hostAddress;} private _hostAddress: string;
    
    public set processes(v: ObservableArray<process>) { this._processes = v; } public get processes(): ObservableArray<process> { return this._processes;} private _processes: ObservableArray<process>;
    public set customServices(v: ObservableArray<customService>) { this._customServices = v; } public get customServices(): ObservableArray<customService> { return this._customServices;} private _customServices: ObservableArray<customService>;
    public set reports(v: ObservableArray<report>) { this._reports = v; } public get reports(): ObservableArray<report> { return this._reports;} private _reports: ObservableArray<report>;
    public set features(v: ObservableArray<Feature>) { this._features = v; } public get features(): ObservableArray<Feature> { return this._features;} private _features: ObservableArray<Feature>;
    public set reorderMenus(v: boolean) { this._reorderMenus = v; } public get reorderMenus(): boolean { return this._reorderMenus;} private _reorderMenus: boolean;
    
    public set selectAllReports(v: boolean) { 
        this._selectAllReports = v; 
        this.reports.forEach(x=>x.isChecked = v);
    } public get selectAllReports(): boolean { return this._selectAllReports;} private _selectAllReports: boolean;
    public set selectAllProcesses(v: boolean) { 
        this._selectAllProcesses = v; 
        this.processes.forEach(x=>x.isChecked = v);
    } public get selectAllProcesses(): boolean { return this._selectAllProcesses;} private _selectAllProcesses: boolean;
    public set selectAllCustomServices(v: boolean) { 
        this._selectAllCustomServices = v; 
        this.customServices.forEach(x=>x.isChecked = v);
    } public get selectAllCustomServices(): boolean { return this._selectAllCustomServices;} private _selectAllCustomServices: boolean;

    async refresh() {
        try {
            this.isLoading = true;
            let promises = [ServerConnection.callServer('/Complex/BpmsRawDataServices/GetAllProcesses',{}),
                            ServerConnection.callServer('/Complex/ReportServices/GetAllReports',{}),
                            ServerConnection.callServer('/Complex/BpmsRawDataServices/GetAllCustomServices',{}),
                            ServerConnection.callServer('/Complex/InstallationFeatureServices/GetNotInstalledFeatures',{})
                        ];
            let [processes,reports,customServices,notInstalledFeature] = await Promise.all(promises);
            this.processes.update(...processes.Processes.map(x=>{
                let r= new process(this);
                r.id = x.Id;
                r.name = x.Name;
                return r;
            }));
            this.reports.update(...reports.Reports.map(x=>{
                let r= new report(this);
                r.id = x.Id;
                r.name = x.Name;
                return r;
            }));
            this.customServices.update(...customServices.CustomServices.map(x=>{
                let r= new customService(this);
                r.id = x.Id;
                r.name = x.Name;
                return r;
            }));
            this.features.update(...notInstalledFeature.Features.map(x=>{
                let r = new Feature(this);
                r.id = x.Id;
                r.content = x.Message;
                r.oldContent = x.Message;
                r.isSaved = true;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    public async publish(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/Publish',{
                Address : this.hostAddress,
                Username : this.username,
                Password : this.password,
                ProcessIds : this.processes.filter(x=>x.isChecked===true).map(x=>x.id),
                ReportIds : this.reports.filter(x=>x.isChecked===true).map(x=>x.id),
                CustomServices : this.customServices.filter(x=>x.isChecked===true).map(x=>x.id),
                FeatureIds : this.features.filter(x=>x.isSaved==true && x.isSelected===true).map(x=>x.id),
                NewFeatureTexts : this.features.filter(x=>x.isSaved==false && x.isSelected===true).map(x=>x.content),
                ReorderMenus : this.reorderMenus
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess('Installation Finished.','Installation');
            }else{
                this.messageBoxConfirmWarning('Error calling server','Error')
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('Error calling server','Error')
        } finally {
            this.isLoading = false;
        }
    }

    verify() : string[]{
        return [];
    }

    addFeature(){
        let feature = new Feature(this);
        this.features.push(feature);
    }

    async deleteFeature(arg0: Feature) {
        try {
            this.isLoading = true;
            let confirmationResult =await this.messageBoxWarningYesNo("Are you sure you want to delete feature?",'Delete');
            if(confirmationResult=='yes'){
                let result = await ServerConnection.callServer('/Complex/InstallationFeatureServices/DeleteInstallationFeature',{
                    Id : arg0.id
                });
                if(result.IsSuccessful){
                    this.features.remove(arg0);
                }
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async saveFeature(arg0: Feature) : Promise<boolean> {
        try {
            this.isLoading = true;
            if(arg0.isSaved==false){
                let result = await ServerConnection.callServer('/Complex/InstallationFeatureServices/CreateNewInstallationFeature',{
                    Message : arg0.content
                });
                if(result.IsSuccessful){
                    arg0.isSaved = true;
                    arg0.id = result.Id
                }else{
                    this.messageBoxConfirmWarning('Error saving data','error')
                }
            }else{
                let result = await ServerConnection.callServer('/Complex/InstallationFeatureServices/UpdateInstallationFeature',{
                    Id : arg0.id,
                    Message : arg0.content
                });
                if(result.IsSuccessful==false){
                    this.messageBoxConfirmWarning('Error saving data','error')
                }
            }
            return true;
        } catch (ex) {
            console.log(ex);
            return false;
        } finally {
            this.isLoading = false;
        }
    }
    
}

export class process extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isChecked(v: boolean) { this._isChecked = v; } public get isChecked(): boolean { return this._isChecked;} private _isChecked: boolean;
}

export class report extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isChecked(v: boolean) { this._isChecked = v; } public get isChecked(): boolean { return this._isChecked;} private _isChecked: boolean;
}

export class customService extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set isChecked(v: boolean) { this._isChecked = v; } public get isChecked(): boolean { return this._isChecked;} private _isChecked: boolean;
}

export class Feature extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PublishViewModel) {
        super(parent);
        this.oldContent = '';
        this._typedParent = parent;
        this.isSaved = false;
    }
    private _typedParent : PublishViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public oldContent:string;
    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    public set isSaved(v: boolean) { this._isSaved = v; } public get isSaved(): boolean { return this._isSaved;} private _isSaved: boolean;
    
    reset(){
        this.content = this.oldContent;
    }

    async save(){
        if(await this._typedParent.saveFeature(this)===true){
            this.oldContent = this.content;
        }
    }

    delete(){
        this._typedParent.deleteFeature(this);
    }
}